// @ts-nocheck
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AutocompleteApiParameter } from "@insite/client-framework/Services/AutocompleteService";
import { getSndProductsAutoComplete } from "@store/Framework/Services/ScratchAndDentService";
import { SndProduct } from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandler<AutocompleteApiParameter & HasOnSuccess<SndProduct[]>, SndProduct[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSndProductsAutoComplete();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getSndProductsAutocompleteModel = createHandlerChainRunner(chain, "GetSndProductsAutocompleteModel");
export default getSndProductsAutocompleteModel;
